import { render, staticRenderFns } from "./shopProductType.vue?vue&type=template&id=0db8dae8&scoped=true"
import script from "./shopProductType.vue?vue&type=script&lang=js"
export * from "./shopProductType.vue?vue&type=script&lang=js"
import style0 from "./shopProductType.vue?vue&type=style&index=0&id=0db8dae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db8dae8",
  null
  
)

export default component.exports